// import React, { useEffect, useState, useCallback } from 'react';
// import { useNavigate, useLocation } from 'react-router-dom';
// import { apiService } from '../../constants/ApiService';
// import {
//   Card,
//   Row,
//   Col,
//   CardTitle,
//   CardBody,
//   Button,
//   Badge,
//   Modal,
//   ModalHeader,
//   ModalBody,
//   ModalFooter,
//   FormGroup,
//   Label,
//   Input,
// } from 'reactstrap';
// import { useSelector } from 'react-redux';
// import { toast } from 'react-toastify';

// const StudentPaymentView = () => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const { user } = useSelector((state) => state.authState);

//   const isStudent =
//     String(user?.user_profile || '').toLowerCase() === 'student';

//   const paymentId = location?.state?.id || 0;

//   const [paymentData, setPaymentData] = useState({
//     id: 0,
//     enrollment_id: '',
//     stud_name: '',
//     batch_id: '',
//     batch_name: '',
//     session_year: '',
//     img_url: '',
//     verified: false,
//     remarks: '',
//     amount: '',
//     vendor_id: 0,
//     branch_id: 0,
//   });

//   const [previewImage, setPreviewImage] = useState('');
//   const [verifyModal, setVerifyModal] = useState(false);
//   const [verifyAmount, setVerifyAmount] = useState('');
//   const [verifyLoading, setVerifyLoading] = useState(false);

//   const toggleVerifyModal = () => {
//     setVerifyModal((prev) => !prev);
//   };

//   const getFileUrl = useCallback((path) => {
//     if (!path) return '';
//     if (/^https?:\/\//i.test(path)) return path;
//     return (process.env.REACT_APP_API_BASE_URL || '') + path;
//   }, []);

//   const loadPayment = useCallback(async () => {
//     try {
//       const query = new URLSearchParams();

//       if (isStudent) {
//         query.append('myOnly', 'true');
//       }

//       if (paymentId) {
//         query.append('id', paymentId);
//       }

//       const res = await apiService.get(
//         `api/StudentPayment/get-payment?${query.toString()}`,
//       );

//       if (res?.status === true && res?.data?.length > 0) {
//         const row = res.data[0];
//         setPaymentData(row);
//         setPreviewImage(getFileUrl(row?.img_url));
//         setVerifyAmount(
//           row?.amount !== null && row?.amount !== undefined ? String(row.amount) : '',
//         );
//       } else {
//         toast.error(res?.message || 'Unable to load payment');
//         navigate('/list-student-payment');
//       }
//     } catch (e) {
//       console.error(e);
//       toast.error('Something went wrong');
//     }
//   }, [getFileUrl, isStudent, paymentId, navigate]);

//   useEffect(() => {
//     loadPayment();
//   }, [loadPayment]);

//   const openVerifyModal = () => {
//     if (!paymentData?.id) {
//       toast.error('Invalid record');
//       return;
//     }

//     setVerifyAmount(
//       paymentData?.amount !== null && paymentData?.amount !== undefined
//         ? String(paymentData.amount)
//         : '',
//     );
//     setVerifyModal(true);
//   };

//   const handleVerify = async () => {
//     if (!paymentData?.id) {
//       toast.error('Invalid record');
//       return;
//     }

//     const parsedAmount = Number(verifyAmount);

//     if (!verifyAmount || Number.isNaN(parsedAmount) || parsedAmount <= 0) {
//       toast.error('Please enter valid paid amount');
//       return;
//     }

//     try {
//       setVerifyLoading(true);

//       const res = await apiService.post('api/StudentPayment/verify-payment', {
//         id: paymentData.id,
//         verified: true,
//         amount: parsedAmount,
//       });

//       if (res?.status === true) {
//         toast.success(res?.message || 'Verified successfully');
//         setVerifyModal(false);
//         await loadPayment();
//       } else {
//         toast.error(res?.message || 'Verification failed');
//       }
//     } catch (error) {
//       console.error(error);
//       toast.error('Something went wrong');
//     } finally {
//       setVerifyLoading(false);
//     }
//   };

//   const renderValue = (value) => {
//     return value !== undefined && value !== null && String(value).trim() !== ''
//       ? value
//       : '-';
//   };

//   return (
//     <>
//       <Card className='card-box pd-20 mb-20 border-0 shadow-sm'>
//         <CardTitle className='border-bottom p-3 d-flex justify-content-between align-items-center'>
//           <span className='fw-bold'>Student Payment Details</span>

//           <div className='d-flex gap-2'>
//             <Button
//               color='warning'
//               onClick={() => navigate('/list-student-payment')}
//             >
//               <i className='bi bi-arrow-left' />
//             </Button>

//             {!isStudent && (
//               <Button
//                 color={paymentData?.verified ? 'success' : 'primary'}
//                 onClick={openVerifyModal}
//                 disabled={paymentData?.verified}
//               >
//                 {paymentData?.verified ? 'Verified' : 'Verify'}
//               </Button>
//             )}
//           </div>
//         </CardTitle>

//         <CardBody>
//           <Row className='g-3'>
//             <Col lg='4' md='5' sm='12'>
//               <div
//                 style={{
//                   border: '1px solid #e9ecef',
//                   borderRadius: '14px',
//                   padding: '16px',
//                   background: '#fff',
//                   boxShadow: '0 2px 10px rgba(0,0,0,0.04)',
//                   height: '100%',
//                 }}
//               >
//                 <div
//                   style={{
//                     fontSize: '13px',
//                     color: '#6c757d',
//                     marginBottom: '12px',
//                     fontWeight: 600,
//                   }}
//                 >
//                   Payment Proof
//                 </div>

//                 {previewImage ? (
//                   <a href={previewImage} target='_blank' rel='noreferrer'>
//                     <img
//                       src={previewImage}
//                       alt='Preview'
//                       style={{
//                         width: '100%',
//                         height: '240px',
//                         borderRadius: '12px',
//                         objectFit: 'cover',
//                         border: '1px solid #ddd',
//                       }}
//                     />
//                   </a>
//                 ) : (
//                   <div
//                     style={{
//                       width: '100%',
//                       height: '240px',
//                       borderRadius: '12px',
//                       backgroundColor: '#f8f9fa',
//                       border: '1px solid #ddd',
//                       display: 'flex',
//                       alignItems: 'center',
//                       justifyContent: 'center',
//                       color: '#6c757d',
//                       fontWeight: 500,
//                     }}
//                   >
//                     No image uploaded
//                   </div>
//                 )}
//               </div>
//             </Col>

//             <Col lg='8' md='7' sm='12'>
//               <div
//                 style={{
//                   border: '1px solid #e9ecef',
//                   borderRadius: '14px',
//                   padding: '18px',
//                   background: '#fff',
//                   boxShadow: '0 2px 10px rgba(0,0,0,0.04)',
//                   height: '100%',
//                 }}
//               >
//                 <div
//                   style={{
//                     fontSize: '13px',
//                     color: '#6c757d',
//                     marginBottom: '16px',
//                     fontWeight: 600,
//                   }}
//                 >
//                   Basic Information
//                 </div>

//                 <Row className='g-3'>
//                   <Col sm='6'>
//                     <div>
//                       <div
//                         style={{
//                           fontSize: '12px',
//                           color: '#6c757d',
//                           marginBottom: '4px',
//                           fontWeight: 500,
//                         }}
//                       >
//                         Student Name
//                       </div>
//                       <div
//                         style={{
//                           fontSize: '15px',
//                           color: '#212529',
//                           fontWeight: 600,
//                           wordBreak: 'break-word',
//                         }}
//                       >
//                         {renderValue(paymentData.stud_name)}
//                       </div>
//                     </div>
//                   </Col>

//                   <Col sm='6'>
//                     <div>
//                       <div
//                         style={{
//                           fontSize: '12px',
//                           color: '#6c757d',
//                           marginBottom: '4px',
//                           fontWeight: 500,
//                         }}
//                       >
//                         Enrollment ID
//                       </div>
//                       <div
//                         style={{
//                           fontSize: '15px',
//                           color: '#212529',
//                           fontWeight: 600,
//                           wordBreak: 'break-word',
//                         }}
//                       >
//                         {renderValue(paymentData.enrollment_id)}
//                       </div>
//                     </div>
//                   </Col>

//                   <Col sm='6'>
//                     <div>
//                       <div
//                         style={{
//                           fontSize: '12px',
//                           color: '#6c757d',
//                           marginBottom: '4px',
//                           fontWeight: 500,
//                         }}
//                       >
//                         Batch Name
//                       </div>
//                       <div
//                         style={{
//                           fontSize: '15px',
//                           color: '#212529',
//                           fontWeight: 600,
//                           wordBreak: 'break-word',
//                         }}
//                       >
//                         {renderValue(paymentData.batch_name)}
//                       </div>
//                     </div>
//                   </Col>

//                   <Col sm='6'>
//                     <div>
//                       <div
//                         style={{
//                           fontSize: '12px',
//                           color: '#6c757d',
//                           marginBottom: '4px',
//                           fontWeight: 500,
//                         }}
//                       >
//                         Session Year
//                       </div>
//                       <div
//                         style={{
//                           fontSize: '15px',
//                           color: '#212529',
//                           fontWeight: 600,
//                           wordBreak: 'break-word',
//                         }}
//                       >
//                         {renderValue(paymentData.session_year)}
//                       </div>
//                     </div>
//                   </Col>

//                   <Col sm='6'>
//                     <div>
//                       <div
//                         style={{
//                           fontSize: '12px',
//                           color: '#6c757d',
//                           marginBottom: '4px',
//                           fontWeight: 500,
//                         }}
//                       >
//                         Amount
//                       </div>
//                       <div
//                         style={{
//                           fontSize: '15px',
//                           color: '#212529',
//                           fontWeight: 600,
//                           wordBreak: 'break-word',
//                         }}
//                       >
//                         {renderValue(paymentData.amount)}
//                       </div>
//                     </div>
//                   </Col>

//                   <Col sm='6'>
//                     <div>
//                       <div
//                         style={{
//                           fontSize: '12px',
//                           color: '#6c757d',
//                           marginBottom: '4px',
//                           fontWeight: 500,
//                         }}
//                       >
//                         Status
//                       </div>
//                       <div>
//                         <Badge
//                           color={paymentData?.verified ? 'success' : 'warning'}
//                           pill
//                         >
//                           {paymentData?.verified ? 'Verified' : 'Pending'}
//                         </Badge>
//                       </div>
//                     </div>
//                   </Col>

//                   <Col sm='6'>
//                     <div>
//                       <div
//                         style={{
//                           fontSize: '12px',
//                           color: '#6c757d',
//                           marginBottom: '4px',
//                           fontWeight: 500,
//                         }}
//                       >
//                         Payment ID
//                       </div>
//                       <div
//                         style={{
//                           fontSize: '15px',
//                           color: '#212529',
//                           fontWeight: 600,
//                           wordBreak: 'break-word',
//                         }}
//                       >
//                         {renderValue(paymentData.id)}
//                       </div>
//                     </div>
//                   </Col>

//                   <Col sm='12'>
//                     <div>
//                       <div
//                         style={{
//                           fontSize: '12px',
//                           color: '#6c757d',
//                           marginBottom: '4px',
//                           fontWeight: 500,
//                         }}
//                       >
//                         Remarks
//                       </div>
//                       <div
//                         style={{
//                           fontSize: '15px',
//                           color: '#212529',
//                           fontWeight: 600,
//                           wordBreak: 'break-word',
//                           whiteSpace: 'pre-wrap',
//                           minHeight: '24px',
//                         }}
//                       >
//                         {renderValue(paymentData.remarks)}
//                       </div>
//                     </div>
//                   </Col>
//                 </Row>
//               </div>
//             </Col>
//           </Row>
//         </CardBody>
//       </Card>

//       <Modal isOpen={verifyModal} toggle={toggleVerifyModal} centered>
//         <ModalHeader toggle={toggleVerifyModal}>Verify Payment</ModalHeader>
//         <ModalBody>
//           <FormGroup>
//             <Label for='verifyAmount'>Paid Amount</Label>
//             <Input
//               id='verifyAmount'
//               type='number'
//               min='0'
//               step='0.01'
//               value={verifyAmount}
//               onChange={(e) => setVerifyAmount(e.target.value)}
//               placeholder='Enter paid amount'
//             />
//           </FormGroup>
//         </ModalBody>
//         <ModalFooter>
//           <Button color='secondary' onClick={toggleVerifyModal} disabled={verifyLoading}>
//             Cancel
//           </Button>
//           <Button color='primary' onClick={handleVerify} disabled={verifyLoading}>
//             {verifyLoading ? 'Verifying...' : 'Verify'}
//           </Button>
//         </ModalFooter>
//       </Modal>
//     </>
//   );
// };

// export default StudentPaymentView;
//Signalr
import React, { useEffect, useState, useCallback, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { apiService } from '../../constants/ApiService';
import {
  Card,
  Row,
  Col,
  CardTitle,
  CardBody,
  Button,
  Badge,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Label,
  Input,
} from 'reactstrap';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import {
  createAppConnection,
  joinModuleGroup,
  leaveModuleGroup,
  subscribeRealtimeUpdate,
  unsubscribeRealtimeUpdate,
} from '../../utils/signalRService';

const MODULE_NAME = 'StudentPayment';

const StudentPaymentView = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useSelector((state) => state.authState || {});

  const isStudent =
    String(user?.user_profile || '').toLowerCase() === 'student';

  const paymentId = location?.state?.id || 0;

  const [paymentData, setPaymentData] = useState({
    id: 0,
    enrollment_id: '',
    stud_name: '',
    batch_id: '',
    batch_name: '',
    session_year: '',
    img_url: '',
    verified: false,
    remarks: '',
    amount: '',
    vendor_id: 0,
    branch_id: 0,
  });

  const [previewImage, setPreviewImage] = useState('');
  const [verifyModal, setVerifyModal] = useState(false);
  const [verifyAmount, setVerifyAmount] = useState('');
  const [verifyLoading, setVerifyLoading] = useState(false);

  const currentGroupRef = useRef({
    module: null,
    vendorId: null,
    branchId: null,
  });

  const toggleVerifyModal = () => {
    setVerifyModal((prev) => !prev);
  };

  const getFileUrl = useCallback((path) => {
    if (!path) return '';
    if (/^https?:\/\//i.test(path)) return path;
    return (process.env.REACT_APP_API_BASE_URL || '') + path;
  }, []);

  const loadPayment = useCallback(async () => {
    try {
      const query = new URLSearchParams();

      if (isStudent) {
        query.append('myOnly', 'true');
      }

      if (paymentId) {
        query.append('id', paymentId);
      }

      const res = await apiService.get(
        `api/StudentPayment/get-payment?${query.toString()}`,
      );

      if (res?.status === true && res?.data?.length > 0) {
        const row = res.data[0];

        setPaymentData({
          id: row?.id || 0,
          enrollment_id: row?.enrollment_id || '',
          stud_name: row?.stud_name || '',
          batch_id: row?.batch_id || '',
          batch_name: row?.batch_name || '',
          session_year: row?.session_year || '',
          img_url: row?.img_url || '',
          verified: !!row?.verified,
          remarks: row?.remarks || '',
          amount:
            row?.amount !== null && row?.amount !== undefined ? row.amount : '',
          vendor_id: row?.vendor_id || 0,
          branch_id: row?.branch_id || 0,
        });

        setPreviewImage(getFileUrl(row?.img_url));
        setVerifyAmount(
          row?.amount !== null && row?.amount !== undefined
            ? String(row.amount)
            : '',
        );
      } else {
        toast.error(res?.message || 'Unable to load payment');
        navigate('/list-student-payment');
      }
    } catch (e) {
      console.error(e);
      toast.error('Something went wrong');
    }
  }, [getFileUrl, isStudent, paymentId, navigate]);

  useEffect(() => {
    loadPayment();
  }, [loadPayment]);

  useEffect(() => {
    let mounted = true;

    const setupSignalR = async () => {
      try {
        await createAppConnection();

        const vendorId = paymentData?.vendor_id || 0;
        const branchId = paymentData?.branch_id || 0;

        if (!vendorId || !branchId) return;

        const prev = currentGroupRef.current;

        if (
          prev.vendorId &&
          prev.branchId &&
          (String(prev.vendorId) !== String(vendorId) ||
            String(prev.branchId) !== String(branchId))
        ) {
          await leaveModuleGroup(prev.module, prev.vendorId, prev.branchId);
        }

        await joinModuleGroup(MODULE_NAME, vendorId, branchId);

        currentGroupRef.current = {
          module: MODULE_NAME,
          vendorId,
          branchId,
        };

        unsubscribeRealtimeUpdate();

        await subscribeRealtimeUpdate(async (payload) => {
          if (!mounted || !payload) return;

          const isSameModule = String(payload.module || '') === MODULE_NAME;
          const isSameVendor =
            String(payload.vendorId || '') === String(vendorId || '');
          const isSameBranch =
            String(payload.branchId || '') === String(branchId || '');
          const isSameRecord =
            String(payload.recordId || '') === String(paymentId || '');

          if (isSameModule && isSameVendor && isSameBranch && isSameRecord) {
            await loadPayment();
          }
        });
      } catch (err) {
        console.error('SignalR error:', err);
      }
    };

    if (paymentData?.vendor_id && paymentData?.branch_id) {
      setupSignalR();
    }

    return () => {
      mounted = false;
      unsubscribeRealtimeUpdate();

      const prev = currentGroupRef.current;
      if (prev?.vendorId && prev?.branchId) {
        leaveModuleGroup(prev.module, prev.vendorId, prev.branchId).catch(
          console.error,
        );
      }
    };
  }, [paymentData?.vendor_id, paymentData?.branch_id, paymentId, loadPayment]);

  const openVerifyModal = () => {
    if (!paymentData?.id) {
      toast.error('Invalid record');
      return;
    }

    setVerifyAmount(
      paymentData?.amount !== null && paymentData?.amount !== undefined
        ? String(paymentData.amount)
        : '',
    );
    setVerifyModal(true);
  };

  const handleVerify = async () => {
    if (!paymentData?.id) {
      toast.error('Invalid record');
      return;
    }

    const parsedAmount = Number(verifyAmount);

    if (!verifyAmount || Number.isNaN(parsedAmount) || parsedAmount <= 0) {
      toast.error('Please enter valid paid amount');
      return;
    }

    try {
      setVerifyLoading(true);

      const res = await apiService.post('api/StudentPayment/verify-payment', {
        id: paymentData.id,
        verified: true,
        amount: parsedAmount,
      });

      if (res?.status === true) {
        toast.success(res?.message || 'Verified successfully');
        setVerifyModal(false);
        await loadPayment();
      } else {
        toast.error(res?.message || 'Verification failed');
      }
    } catch (error) {
      console.error(error);
      toast.error('Something went wrong');
    } finally {
      setVerifyLoading(false);
    }
  };

  const renderValue = (value) => {
    return value !== undefined && value !== null && String(value).trim() !== ''
      ? value
      : '-';
  };

  return (
    <>
      <Card className='card-box pd-20 mb-20 border-0 shadow-sm'>
        <CardTitle className='border-bottom p-3 d-flex justify-content-between align-items-center'>
          <span className='fw-bold'>Student Payment Details</span>

          <div className='d-flex gap-2'>
            <Button
              color='warning'
              onClick={() => navigate('/list-student-payment')}
            >
              <i className='bi bi-arrow-left' />
            </Button>

            {!isStudent && (
              <Button
                color={paymentData?.verified ? 'success' : 'primary'}
                onClick={openVerifyModal}
                disabled={paymentData?.verified}
              >
                {paymentData?.verified ? 'Verified' : 'Verify'}
              </Button>
            )}
          </div>
        </CardTitle>

        <CardBody>
          <Row className='g-3'>
            <Col lg='4' md='5' sm='12'>
              <div
                style={{
                  border: '1px solid #e9ecef',
                  borderRadius: '14px',
                  padding: '16px',
                  background: '#fff',
                  boxShadow: '0 2px 10px rgba(0,0,0,0.04)',
                  height: '100%',
                }}
              >
                <div
                  style={{
                    fontSize: '13px',
                    color: '#6c757d',
                    marginBottom: '12px',
                    fontWeight: 600,
                  }}
                >
                  Payment Proof
                </div>

                {previewImage ? (
                  <a href={previewImage} target='_blank' rel='noreferrer'>
                    <img
                      src={previewImage}
                      alt='Preview'
                      style={{
                        width: '100%',
                        height: '240px',
                        borderRadius: '12px',
                        objectFit: 'cover',
                        border: '1px solid #ddd',
                      }}
                    />
                  </a>
                ) : (
                  <div
                    style={{
                      width: '100%',
                      height: '240px',
                      borderRadius: '12px',
                      backgroundColor: '#f8f9fa',
                      border: '1px solid #ddd',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: '#6c757d',
                      fontWeight: 500,
                    }}
                  >
                    No image uploaded
                  </div>
                )}
              </div>
            </Col>

            <Col lg='8' md='7' sm='12'>
              <div
                style={{
                  border: '1px solid #e9ecef',
                  borderRadius: '14px',
                  padding: '18px',
                  background: '#fff',
                  boxShadow: '0 2px 10px rgba(0,0,0,0.04)',
                  height: '100%',
                }}
              >
                <div
                  style={{
                    fontSize: '13px',
                    color: '#6c757d',
                    marginBottom: '16px',
                    fontWeight: 600,
                  }}
                >
                  Basic Information
                </div>

                <Row className='g-3'>
                  <Col sm='6'>
                    <div>
                      <div
                        style={{
                          fontSize: '12px',
                          color: '#6c757d',
                          marginBottom: '4px',
                          fontWeight: 500,
                        }}
                      >
                        Student Name
                      </div>
                      <div
                        style={{
                          fontSize: '15px',
                          color: '#212529',
                          fontWeight: 600,
                          wordBreak: 'break-word',
                        }}
                      >
                        {renderValue(paymentData.stud_name)}
                      </div>
                    </div>
                  </Col>

                  <Col sm='6'>
                    <div>
                      <div
                        style={{
                          fontSize: '12px',
                          color: '#6c757d',
                          marginBottom: '4px',
                          fontWeight: 500,
                        }}
                      >
                        Enrollment ID
                      </div>
                      <div
                        style={{
                          fontSize: '15px',
                          color: '#212529',
                          fontWeight: 600,
                          wordBreak: 'break-word',
                        }}
                      >
                        {renderValue(paymentData.enrollment_id)}
                      </div>
                    </div>
                  </Col>

                  <Col sm='6'>
                    <div>
                      <div
                        style={{
                          fontSize: '12px',
                          color: '#6c757d',
                          marginBottom: '4px',
                          fontWeight: 500,
                        }}
                      >
                        Batch Name
                      </div>
                      <div
                        style={{
                          fontSize: '15px',
                          color: '#212529',
                          fontWeight: 600,
                          wordBreak: 'break-word',
                        }}
                      >
                        {renderValue(paymentData.batch_name)}
                      </div>
                    </div>
                  </Col>

                  <Col sm='6'>
                    <div>
                      <div
                        style={{
                          fontSize: '12px',
                          color: '#6c757d',
                          marginBottom: '4px',
                          fontWeight: 500,
                        }}
                      >
                        Session Year
                      </div>
                      <div
                        style={{
                          fontSize: '15px',
                          color: '#212529',
                          fontWeight: 600,
                          wordBreak: 'break-word',
                        }}
                      >
                        {renderValue(paymentData.session_year)}
                      </div>
                    </div>
                  </Col>

                  <Col sm='6'>
                    <div>
                      <div
                        style={{
                          fontSize: '12px',
                          color: '#6c757d',
                          marginBottom: '4px',
                          fontWeight: 500,
                        }}
                      >
                        Amount
                      </div>
                      <div
                        style={{
                          fontSize: '15px',
                          color: '#212529',
                          fontWeight: 600,
                          wordBreak: 'break-word',
                        }}
                      >
                        {renderValue(paymentData.amount)}
                      </div>
                    </div>
                  </Col>

                  <Col sm='6'>
                    <div>
                      <div
                        style={{
                          fontSize: '12px',
                          color: '#6c757d',
                          marginBottom: '4px',
                          fontWeight: 500,
                        }}
                      >
                        Status
                      </div>
                      <div>
                        <Badge
                          color={paymentData?.verified ? 'success' : 'warning'}
                          pill
                        >
                          {paymentData?.verified ? 'Verified' : 'Pending'}
                        </Badge>
                      </div>
                    </div>
                  </Col>

                  <Col sm='6'>
                    <div>
                      <div
                        style={{
                          fontSize: '12px',
                          color: '#6c757d',
                          marginBottom: '4px',
                          fontWeight: 500,
                        }}
                      >
                        Payment ID
                      </div>
                      <div
                        style={{
                          fontSize: '15px',
                          color: '#212529',
                          fontWeight: 600,
                          wordBreak: 'break-word',
                        }}
                      >
                        {renderValue(paymentData.id)}
                      </div>
                    </div>
                  </Col>

                  <Col sm='12'>
                    <div>
                      <div
                        style={{
                          fontSize: '12px',
                          color: '#6c757d',
                          marginBottom: '4px',
                          fontWeight: 500,
                        }}
                      >
                        Remarks
                      </div>
                      <div
                        style={{
                          fontSize: '15px',
                          color: '#212529',
                          fontWeight: 600,
                          wordBreak: 'break-word',
                          whiteSpace: 'pre-wrap',
                          minHeight: '24px',
                        }}
                      >
                        {renderValue(paymentData.remarks)}
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </CardBody>
      </Card>

      <Modal isOpen={verifyModal} toggle={toggleVerifyModal} centered>
        <ModalHeader toggle={toggleVerifyModal}>Verify Payment</ModalHeader>
        <ModalBody>
          <FormGroup>
            <Label for='verifyAmount'>Paid Amount</Label>
            <Input
              id='verifyAmount'
              type='number'
              min='0'
              step='0.01'
              value={verifyAmount}
              onChange={(e) => setVerifyAmount(e.target.value)}
              placeholder='Enter paid amount'
            />
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button
            color='secondary'
            onClick={toggleVerifyModal}
            disabled={verifyLoading}
          >
            Cancel
          </Button>
          <Button
            color='primary'
            onClick={handleVerify}
            disabled={verifyLoading}
          >
            {verifyLoading ? 'Verifying...' : 'Verify'}
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default StudentPaymentView;
